module.exports = __webpack_public_path__ + "img/basic-globe.fc6b9d45.svg";